import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEImmigrationProceedingsCardActions = {
  initPeImmigrationProceedingsCard: ({ commit }, index) => {
    commit('setPeImmigrationProceedingsCardLock', { index, lock: true })
  },
  peImmigrationProceedingsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        immigration_proceedings: {
          party_id: party.id,
          hearing_type: section.hearing_type,
          initiated_date: section.initiated_date,
          initiated_date_format: section.initiated_date_format,
          initiated_date_uncertain: section.initiated_date_uncertain,
          hearing_date: section.hearing_date,
          hearing_date_format: section.hearing_date_format,
          removal_outcome: section.removal_outcome,
          expedited_removal_outcome: section.expedited_removal_outcome,
          outcome_date: section.outcome_date,
          outcome_date_format: section.outcome_date_format,
          outcome_date_uncertain: section.outcome_date_uncertain,
          appeal_jurisdiction: section.appeal_jurisdiction,
          proceeding_jurisdiction: section.proceeding_jurisdiction,
          fear_expressed: section.fear_expressed,
          fear_date: section.fear_date,
          fear_date_format: section.fear_date_format,
          fear_date_uncertain: section.fear_date_uncertain,
          fear_interview_outcome: section.fear_interview_outcome,
          fear_interview_outcome_date: section.fear_interview_outcome_date,
          fear_interview_outcome_date_format: section.fear_interview_outcome_date_format,
          fear_outcome_date_uncertain: section.fear_outcome_date_uncertain,
          fear_ao_jurisdiction: section.fear_ao_jurisdiction,
          fear_review_outcome: section.fear_review_outcome,
          fear_review_date: section.fear_review_date,
          fear_review_date_format: section.fear_review_date_format,
          fear_review_date_uncertain: section.fear_review_date_uncertain,
          fear_review_jurisdiction: section.fear_review_jurisdiction,
          immigration_judge: section.immigration_judge,
          federal_action: section.federal_action,
          notes: section.notes,
          charges: section.charges,
        },
      }).
      then(({ data }) => {
        commit('setPeImmigrationProceedingsCardLock', { index: 'new', lock: true })
        commit('setPeImmigrationProceedingsCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'immigration_proceedings',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationProceedingsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/immigration_proceedings/${section.id}`).
      then(({ data }) => {
        commit('setPeImmigrationProceedingsCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_proceedings',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationProceedingsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        immigration_proceedings: {
          party_id: party.id,
          hearing_type: section.hearing_type,
          initiated_date: section.initiated_date,
          initiated_date_format: section.initiated_date_format,
          initiated_date_uncertain: section.initiated_date_uncertain,
          hearing_date: section.hearing_date,
          hearing_date_format: section.hearing_date_format,
          removal_outcome: section.removal_outcome,
          expedited_removal_outcome: section.expedited_removal_outcome,
          outcome_date: section.outcome_date,
          outcome_date_format: section.outcome_date_format,
          outcome_date_uncertain: section.outcome_date_uncertain,
          appeal_jurisdiction: section.appeal_jurisdiction,
          proceeding_jurisdiction: section.proceeding_jurisdiction,
          fear_expressed: section.fear_expressed,
          fear_date: section.fear_date,
          fear_date_format: section.fear_date_format,
          fear_date_uncertain: section.fear_date_uncertain,
          fear_interview_outcome: section.fear_interview_outcome,
          fear_interview_outcome_date: section.fear_interview_outcome_date,
          fear_interview_outcome_date_format: section.fear_interview_outcome_date_format,
          fear_outcome_date_uncertain: section.fear_outcome_date_uncertain,
          fear_ao_jurisdiction: section.fear_ao_jurisdiction,
          fear_review_outcome: section.fear_review_outcome,
          fear_review_date: section.fear_review_date,
          fear_review_date_format: section.fear_review_date_format,
          fear_review_date_uncertain: section.fear_review_date_uncertain,
          fear_review_jurisdiction: section.fear_review_jurisdiction,
          immigration_judge: section.immigration_judge,
          federal_action: section.federal_action,
          notes: section.notes,
          charges: section.charges,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeImmigrationProceedingsCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_proceedings',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationProceedingsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          immigration_proceedings: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const immigrationProceedings = data.immigration_proceedings

        commit('setPeImmigrationProceedingsCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_proceedings: immigrationProceedings || [],
        })
      }).
      catch(handleError)
  },
  peImmigrationProceedingsCardAddSection: ({ commit }) => {
    commit('setPeImmigrationProceedingsCardLock', { index: 'new', lock: false })
    commit('addPeImmigrationProceedingsCardSection', {
      id: null,
      hearing_type: null,
      initiated_date: null,
      initiated_date_format: null,
      initiated_date_uncertain: null,
      hearing_date: null,
      hearing_date_format: null,
      removal_outcome: null,
      expedited_removal_outcome: null,
      outcome_date: null,
      outcome_date_format: null,
      outcome_date_uncertain: null,
      appeal_jurisdiction: null,
      proceeding_jurisdiction: null,
      fear_expressed: null,
      fear_date: null,
      fear_date_format: null,
      fear_date_uncertain: null,
      fear_interview_outcome: null,
      fear_interview_outcome_date: null,
      fear_interview_outcome_date_format: null,
      fear_outcome_date_uncertain: null,
      fear_ao_jurisdiction: null,
      fear_review_outcome: null,
      fear_review_date: null,
      fear_review_date_format: null,
      fear_review_date_uncertain: null,
      fear_review_jurisdiction: null,
      immigration_judge: null,
      federal_action: null,
      notes: null,
      charges: null,
    })
  },
}

export const PEImmigrationProceedingsCardMutations = {
  setPeImmigrationProceedingsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ImmigrationProceedingsCard) {
      Vue.set(state.partyEdit.partySections, 'ImmigrationProceedingsCard', {})
    }
    Vue.set(state.partyEdit.partySections.ImmigrationProceedingsCard, index, lock)
  },
  addPeImmigrationProceedingsCardSection: (state, section) => {
    state.partyEdit.party.immigration_proceedings.push(section)
  },
  peImmigrationProceedingsCardCreateUndo: state => {
    state.partyEdit.party.immigration_proceedings.pop()
    Vue.set(state.partyEdit.partySections.ImmigrationProceedingsCard, 'new', true)
  },
}

export const PEImmigrationProceedingsCardGetters = {
  peImmigrationProceedingsCardLock: state => index => state.partyEdit.partySections.ImmigrationProceedingsCard[index],
  peImmigrationProceedingsCardHasNewSection: (_, getters) => !!getters.
    peParty.
    immigration_proceedings?.
    find(proceeding => proceeding.id === null),
}
